const EXECUTABLE_DIFFICULTIES = new Set(['easy', 'medium', 'hard']);

export const isExecutableHomeworkItem = (item = {}) => {
  const questionCount = Number(item.numberOfQues);
  return item.source === 'booster_executable'
    && item.subtype === 'BOOSTER_EXECUTABLE'
    && Number(item.subtypeVersion) === 1
    && Boolean(String(item.topic || '').trim())
    && Boolean(String(item.topicId || '').trim())
    && EXECUTABLE_DIFFICULTIES.has(String(item.difficulty || '').trim().toLowerCase())
    && Number.isInteger(questionCount)
    && questionCount >= 1
    && questionCount <= 100;
};

export const executableIncompleteHomework = (rows = []) =>
  (Array.isArray(rows) ? rows : []).filter((row) => {
    const items = Array.isArray(row?.assignments) ? row.assignments.filter(isExecutableHomeworkItem) : [];
    return items.length > 0 && items.some((item) => !item.completed);
  });

export const decideHomeRecommendation = (rows = []) => {
  const pending = executableIncompleteHomework(rows);
  return pending.length
    ? { kind: 'ASSIGNED_HOMEWORK', count: pending.length, title: 'Continue your assigned Booster Homework.' }
    : { kind: 'GENERIC_PRACTICE', count: 0, title: 'Practice for 10 minutes today.' };
};
